import { cloneDeep } from 'lodash';
import Vue from 'vue';
let started = false;

const Ana = {};
Ana.install = function (Vue, options) {
  Vue.mixin({
    // Anything added to a mixin will be injected into all components.
    // In this case, the mounted() method runs when the component is added to the DOM.
    beforeMount() {
      this.$ana = {
        //track: async (name, data, category='edit') => {
        track: (data) => {
          this.$eventbus.emit('ana', data);
        }
      }
    }
  });
  /*
  {
    track: () => {
      console.log('am have this', this);
    }
  }
  */
}

export default Ana;
